import { render } from "./FormDetailLoader.vue?vue&type=template&id=c6418866&scoped=true"
const script = {}

import "./FormDetailLoader.vue?vue&type=style&index=0&id=c6418866&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6418866"]])

export default __exports__